import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import Swiper from 'react-id-swiper';
import OutsideNotifier from './../../OutsideNotifier';
import config from './../../config';
import common from './../../common';
import moment from 'moment';
import { isEmpty, find } from 'lodash'
import {
    addOrRemovePlayer,
    removePlayer,
    makeCaptain,
    playerCardFetchData,
    triggerHandlePlayerCard,
    triggerLiveScoreFetchData,
    setManageTeamMode,
    openMobilePlayerListing,
    triggerPlayerSkillsFilter,

} from './../../actions/FormationActions';
import {
    initiateSubstitution,
    makeSubstitution,
    cancelSubstitution,
} from './../../actions/ManageTeamActions';
import {
    resetAllFilters,
    triggerResetSkillsFilter
} from './../../actions/FilterActions';
import {
    isPlayerInTeam,
    isPlayerInBench,
    isCaptain,
    getState,
    canPlayerSubstitute,
    getPlayerDBDetails,
    getPlayerByKeyFromTeamData
} from "./../../helper";
import {

    getTeamDeadlineObj,
} from "../../helper-common";

import routeObject from '../../constants/new-pageTrackEvents'

class PlayerCard extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            scrollTop: 0,
            toShowCaptainInfo: false,
            selectedJersey: null,
            showPtsSysTooltip: false,
        };
        this.handleUpdate = this.handleUpdate.bind(this);
    }

    handleUpdate(values) {
        const { scrollTop } = values;
        const playerInfoHeader = document.getElementsByClassName('si-plyr-info-header')[0];
        if (playerInfoHeader) {
            if (scrollTop > 20) {
                playerInfoHeader.classList.add('si-small-header', 'si-on-scroll-gradient');
            } else {
                playerInfoHeader.classList.remove('si-small-header', 'si-on-scroll-gradient');
            }
        }
        if (scrollTop !== this.state.scrollTop) {
            this.setState({ scrollTop });
        }
    }

    setCommonState(nextProps) {
        let playerCardDetails = nextProps.playerCardDetails;
        let isPlayerCardVisible = nextProps.isPlayerCardVisible;
        let trans = nextProps.trans;
        this.setState({ playerCardDetails, isPlayerCardVisible, trans });
    }

    componentDidMount() {
        this.props.playerCardFetchData(this.props.playerCardDetails.Id);
        // is from info clicked

        // this.props.triggerLiveScoreFetchData();
    }

    componentWillUnmount() {
        let bodyElem = document.body;
        bodyElem.classList.remove('bodyNoScroll');
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.playerData && nextProps.playerData.pData && nextProps.playerData.pData.pDataPer) {
            if (!nextProps.playerData.pData.hasAddedLiveScoringData) {
                const popupData = nextProps.playerData.pData || {};
                if (+nextProps.playerCardDetails.Id === +popupData.Id) {
                    let playerHasLiveMatch = false;
                    let matchDay = popupData.pDataPer ? popupData.pDataPer : [];
                    for (let i = 0; i < matchDay.length; i++) {
                        if (+matchDay[i].MStatus === 1) {
                            playerHasLiveMatch = true;
                            break;
                        }
                    }
                    if (playerHasLiveMatch) {
                        this.props.triggerLiveScoreFetchData();
                    }
                }
            }
        }
        this.setCommonState(nextProps);
    }

    closePopup = () => {
        let bodyElem = document.body;
        bodyElem.classList.remove('bodyNoScroll');
        this.props.triggerHandlePlayerCard(false, null);
    };

    openMobilePlayerListing = (bool, skill) => {
        let self = this;
        this.closePopup();
        this.props.triggerResetSkillsFilter();
        setTimeout(function () {
            self.props.triggerPlayerSkillsFilter(skill);
            common.customTracking('View Players - Player Card', '/uclfantasy/my-team/transfers/');
            if (common.isMobile()) {
                self.props.openMobilePlayerListing(bool);
            }

        }, 100)
    }

    recoverPlayer = (e, player, objKey, playerIndex, from) => {
        e.stopPropagation();
        //get objKey
        //ie row index
        let self = this;
        if (from == "fromPlayerInfo") {
            // kept for futher implementation
            common.customTracking('Recover - Player Card', '/uclfantasy/my-team/transfers/');
        } else {
            common.customTracking('Recover - Player Card', '/uclfantasy/my-team/transfers/');
        }

        const orderToScan = ['4', '3', '2', '1', '0'];
        find(orderToScan, (position) => {
            find(self.props.teamData[position], (teamPlayer, index) => {
                if (player.Id == teamPlayer.DBDetails.Id) {
                    objKey = position;
                }

            });
        });
        this.props.removePlayer({ player, objKey, playerIndex });
    }
    addOrRemovePlyrBtn = (playerObj) => {
        let pageName = "";
        if (window.location.pathname.indexOf("/manage-team")) {
            pageName = "/uclfantasy/my-team/transfers/"
        } else {
            pageName = "/uclfantasy/create-team/"
        }
        common.customTracking('Add Player - Player Card', pageName);
        this.props.addOrRemovePlayer(playerObj);
    };
    removePlyrBtn = (e, player, objKey, playerIndex) => {
        e.stopPropagation();
        let pageName = "";
        if (window.location.pathname.indexOf("/manage-team")) {
            pageName = "/uclfantasy/my-team/transfers/"
        } else {
            pageName = "/uclfantasy/create-team/"
        }
        common.customTracking('Remove Player - Player Card', pageName);
        this.setState({ selectedJersey: null });
        this.props.removePlayer({ player, objKey, playerIndex });
    };
    onMakeCaptainTap = (e, player, objKey, playerIndex, saveCaptain) => {
        e.stopPropagation();
        this.closePopup();
        let pageName = "";
        if (window.location.pathname.indexOf("/manage-team")) {
            pageName = "/uclfantasy/my-team/manage/"
        } else {
            pageName = "/uclfantasy/create-team/"
        }
        common.customTracking('Captain - Player Card', pageName);
        if (saveCaptain) {
            this.props.captainChangePopup(player.Id);
        } else {
            this.props.makeCaptain({ player, objKey, playerIndex });
        }
    };
    onGraphTap = (gd) => {
        this.setState({ matchDayData: gd });
    };
    changeManageTeamView = (e, removeThis, mode, player, objKey, playerIndex) => {
        e.stopPropagation();
        this.closePopup();
        this.props.resetAllFilters();
        this.props.setManageTeamMode(mode);
        if (mode === config.modes["substitution"]) {
            common.customTracking('Start Substitutes - Player Card', '/uclfantasy/my-team/manage/');
            this.props.initiateSubstitution(player);
        } else {
            if (removeThis) {
                common.customTracking('Start Transfers - Player Card', '/uclfantasy/my-team/manage/');
                common.pageViewTracking("", routeObject["transfer"]);
                this.onRemoveTap(e, player, objKey, playerIndex);
            }
        }
    };
    onRemoveTap = (e, player, objKey, playerIndex) => {
        e.stopPropagation();
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        this.props.removePlayer({ player, objKey, playerIndex });
    };
    canSubstitute = (player) => {
        const substituteThisPlyr = canPlayerSubstitute(player);
        return substituteThisPlyr;
    };
    canBeCaptain = (player) => {
        const { isCaptain, isBench } = player;
        const hasTeam = common.isManageTeam();
        let canBeCaptain = false;
        if (hasTeam) {
            const captainObj = getPlayerByKeyFromTeamData(this.props.teamData, 'isCaptain', true);
            const captainHasRedCard = captainObj.data && captainObj.data.DBDetails && captainObj.data.DBDetails.IsRedCard;
            // const playerHasIsPlayed = player.DBDetails && player.DBDetails.IsPlayed;
            // canBeCaptain = !captainHasRedCard && !playerHasIsPlayed && !isBench && !isCaptain;
            const playerHasIsPlayed = player.DBDetails && player.DBDetails.IsPlayed;
            canBeCaptain = !playerHasIsPlayed && !isBench && !isCaptain;
        } else {
            canBeCaptain = !isBench && !isCaptain;
        }
        return canBeCaptain;
    }
    findTeamPlayer = (playerId, positionKey) => {
        const newRawData = this.props.teamData;
        let pData = null;
        for (let i = 0; i < newRawData[positionKey].length; i++) {
            let plyr = newRawData[positionKey][i];
            if (plyr.id === playerId) {
                pData = plyr;
                break;
            }
        }
        return pData;
    };
    substitutePlayer = (e, player) => {
        this.props.initiateSubstitution(player);
        this.closePopup();
    };

    makeSubstitution = (player) => {
        if (player.couldBeUsedToReplace) {
            this.props.makeSubstitution(player);
        } else {
            this.props.initiateSubstitution(player);
        }

        this.closePopup();
    };
    cancelSubstitution = (player) => {
        common.customTracking('Cancel Substitute - Player Card', '/uclfantasy/my-team/substitutions/');
        this.props.cancelSubstitution(player);
        this.closePopup();
    };

    onPtsSysIconClick = () => {
        const showTooltip = this.state.showPtsSysTooltip;
        if (!showTooltip) {
            this.setState({ showPtsSysTooltip: true });
        } else {
            this.setState({ showPtsSysTooltip: false });
        }
    };

    render() {
        const { matchDayData, showPtsSysTooltip } = this.state;
        const { playerCardDetails, isPlayerCardVisible, trans, manageTeamPlayersInTeam, fromPlayerInfo } = this.props;
        let bodyElem = document.body;
        if (!isPlayerCardVisible) {
            bodyElem.classList.remove('bodyNoScroll');
            return null;
        } else {
            bodyElem.classList.add('bodyNoScroll');
        }
        const isManageTeam = common.isManageTeam();
        let getViewState = null;
        let currGDFromConst = this.props.constraints.GamedayId;
        if (isManageTeam) {
            const { userSpecificFixtures, currentActiveFixture } = this.props;
            if (userSpecificFixtures && userSpecificFixtures.length) {
                const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
                if (currentFixture) {
                    getViewState = getState(currentFixture);
                }

                currGDFromConst = currentFixture.GDID || currGDFromConst;
            }

        }
        if (this.props.overview) {
            currGDFromConst = parseInt(this.props.GDIDFromFetch);
        }

        const pData = this.props.playerData.pData;
        let tData = {};
        if (!isEmpty(this.props.teamData)) {
            tData = this.props.teamData
        } else {
            tData["playersInTeam"] = this.props.friendsTeamData
        }
        let ID = playerCardDetails.Id;
        pData.isPlayInTeam = isPlayerInTeam(ID, tData);
        pData.isPlayInBench = isPlayerInBench(ID, tData);
        playerCardDetails.DBDetails = getPlayerDBDetails(ID, tData);
        if (isEmpty(playerCardDetails.DBDetails) && this.props.overview) {
            playerCardDetails.DBDetails = playerCardDetails;
        }
        pData.isCaptain = isCaptain(ID, tData);
        const buttonViewStates = {
            isManageTeam: common.isManageTeam(),
            manageTeamMode: this.props.manageTeamMode,
            getViewState: getViewState ? getViewState : null,
            configModes: config.modes,
            configPossibleActions: config.possibleActions,
            changeManageTeamView: this.changeManageTeamView,
            canSubstitute: this.canSubstitute,
            findTeamPlayer: this.findTeamPlayer,
            playerCount: this.props.teamData.playerCount,
            maxPerTeamCount: config.MAX_PLAYERS_PER_TEAM,
            substitutePlayer: this.substitutePlayer,
            canBeCaptain: this.canBeCaptain,
            makeSubstitution: this.makeSubstitution,
            cancelSubstitution: this.cancelSubstitution
        };
        let pStatus = playerCardDetails.PStatus;
        let pStatusObj = config.playerStatusObj ? config.playerStatusObj : {};
        playerCardDetails.pStatusText = pStatusObj[pStatus] ? trans[pStatusObj[pStatus]["transKey"]] : '';
        playerCardDetails.pStatusHeaderClass = pStatusObj[pStatus] ? pStatusObj[pStatus]["playerInfoHeaderClass"] : '';
        playerCardDetails.hasStatus = playerCardDetails.pStatusHeaderClass !== '';
        let playerInfoHeaderClass = 'si-plyr-info-header ' + (playerCardDetails.pStatusHeaderClass);
        return <div id={ "playerCardModal" }>
            <div className="si-modal-wrap">
                <OutsideNotifier handler={ () => this.closePopup() }>
                    <div className="si-plyr-details-card">
                        <div className={ playerInfoHeaderClass }>
                            {
                                Object.keys(playerCardDetails).length > 0 ?
                                    <PlayerCardHeaderBio playerCardDetails={ playerCardDetails } config={ config } /> : ''
                            }
                            <i className="si-close icon-ucl-close" onClick={ () => this.closePopup() } />
                        </div>
                        <div className="si-plyr-info-body">

                            <Scrollbars onUpdate={ this.handleUpdate } autoHide>
                                {
                                    this.props.overview ? null : Object.keys(pData).length > 0 ?
                                        <PlayerCardHeader pData={ pData } tData={ tData } teamData={ tData } playerCardDetails={ playerCardDetails }
                                            trans={ trans }
                                            config={ config } addOrRemovePlyrBtn={ this.addOrRemovePlyrBtn }
                                            removePlyrBtn={ this.removePlyrBtn }
                                            onMakeCaptainTap={ this.onMakeCaptainTap }
                                            openMobilePlayerListing={ this.openMobilePlayerListing }
                                            manageTeamPlayersInTeam={ manageTeamPlayersInTeam }
                                            fromPlayerInfo={ fromPlayerInfo }
                                            recoverPlayer={ this.recoverPlayer }
                                            buttonViewStates={ buttonViewStates } /> : ''
                                }
                                {
                                    Object.keys(playerCardDetails).length > 0 ?
                                        <PlayerCardStatus playerCardDetails={ playerCardDetails } trans={ trans }
                                            pData={ pData } /> : ''
                                }
                                {
                                    Object.keys(pData).length > 0 ?
                                        <PlayerCardGraph pData={ pData } playerCardDetails={ playerCardDetails }
                                            trans={ trans } currGDFromConst={ currGDFromConst }
                                            onGraphTap={ this.onGraphTap } matchDayData={ matchDayData } OppCurrTeamGDID={ this.props.OppCurrTeamGDID } overview={ this.props.overview } gameday={ this.props.gameday } /> : ''
                                }
                                {
                                    Object.keys(pData).length > 0 && matchDayData ?
                                        <PlayerStatsByMatchDay pData={ pData } trans={ trans } matchDayData={ matchDayData }
                                            config={ config }
                                            { ...this.props }
                                            playerCardDetails={ playerCardDetails } /> : ''
                                }
                                {
                                    (pData.OverallStats && Object.keys(pData.OverallStats).length > 0) ?
                                        <SeasonStats pData={ pData } trans={ trans } config={ config }
                                            onPtsSysIconClick={ this.onPtsSysIconClick }
                                            showTooltip={ showPtsSysTooltip } /> : ''
                                }
                            </Scrollbars>
                        </div>
                    </div>
                </OutsideNotifier>
            </div>
        </div>
    }
}

class PlayerCardHeaderBio extends Component {
    render() {
        const config = this.props.config;
        const playerCardDetails = this.props.playerCardDetails;
        let ID = playerCardDetails.Id;
        let TID = playerCardDetails.TID || playerCardDetails.TeamId;
        let plyImg = config.UEFAImgBase + `players/1/2020/324x324/${ID}.jpg`;
        let tmImg = config.UEFAImgBase + `teams/logos/140x140/${TID}.png`;
        let tName = playerCardDetails.TName;
        let pName = playerCardDetails.PFName || playerCardDetails.DisplayName || playerCardDetails.PlayerDisplayName;
        let pPosId = playerCardDetails.Skill;
        let pPosAbbr = config.playerPos[(pPosId - 1)];
        let pStatusText = playerCardDetails.pStatusText;
        let hasStatus = playerCardDetails.hasStatus;
        return <React.Fragment>
            <div className="si-status-wrap">
                <div className="si-thumbnail-wrap">
                    <span className="si-thumbnail">
                        <img src={ plyImg } alt="" />
                    </span>
                </div>
                { hasStatus ? <span className="si-status-icon" /> : null }
                <span className="si-club-icon">
                    <img src={ tmImg } alt="" />
                </span>
            </div>
            <div className="si-plyr-info">
                <span className="si-plyr-status">{ pStatusText }</span>
                <span className="si-plyr-name">{ pName }</span>
                <span className="si-plyr-club">{ tName } - { pPosAbbr }</span>
            </div>
        </React.Fragment>
    }
}

class PlayerCardHeader extends Component {
    render() {
        const trans = this.props.trans;
        const pData = this.props.pData;
        const tData = this.props.tData;
        const addOrRemovePlyrBtn = this.props.addOrRemovePlyrBtn;
        const openMobilePlayerListing = this.props.openMobilePlayerListing;
        const recoverPlayer = this.props.recoverPlayer;
        const playerCardDetails = this.props.playerCardDetails;
        const removePlyrBtn = this.props.removePlyrBtn;
        const onMakeCaptainTap = this.props.onMakeCaptainTap;
        const objKey = this.props.objKey;
        const playerIndex = this.props.index;
        const teamData = this.props.teamData;
        const manageTeamPlayersInTeam = this.props.manageTeamPlayersInTeam;
        const fromPlayerInfo = this.props.fromPlayerInfo;
        const { isManageTeam, manageTeamMode, configModes, getViewState, configPossibleActions, changeManageTeamView, findTeamPlayer, playerCount, maxPerTeamCount, canBeCaptain, makeSubstitution, cancelSubstitution, canSubstitute } = this.props.buttonViewStates;
        let isViewManageTeam = isManageTeam && manageTeamMode === configModes["view-manage-team"];
        let isTransferMode = isManageTeam && manageTeamMode === configModes["transfer"];
        let isTransAllow = isManageTeam && (getViewState === configPossibleActions["subsAndTransfer"] || getViewState === configPossibleActions["transfer"]);
        const substitutionMode = manageTeamMode === config.modes["substitution"];
        let viewOnly = (getViewState === configPossibleActions["live"] || getViewState === configPossibleActions["viewpoint"]);
        let isPlayInTeam = pData.isPlayInTeam;
        let isPlayInBench = pData.isPlayInBench;
        let isCaptain = pData.isCaptain;
        let playerButtons = null;


        if (viewOnly) {
            // playerButtons = isCaptain ? <div className="si-action-items-wrap">
            //     <div className="si-action-items si-captain-icon si-if-captain">
            //         <span className="si-icon-wrap">
            //             <i className="icon-ucl-captain" />
            //         </span>
            //         <div className="si-action-text">{ trans.isCaptain }</div>
            //     </div>
            // </div> : null;
            playerButtons = null;
        } else {
            let onMakeCaptainHandler = {
                onClick: () => {
                }
            };
            if (isPlayInTeam) {
                const positionKey = isPlayInBench ? 0 : playerCardDetails.Skill;
                const playerTotalData = findTeamPlayer(playerCardDetails.Id, positionKey);
                /* captain button */
                let CaptainIconClass = common.makeClasses({
                    'si-action-items': true,
                    'si-captain-icon': true,
                    'si-if-captain': isCaptain
                });
                if (!isCaptain) {
                    onMakeCaptainHandler = { onClick: (e) => onMakeCaptainTap(e, playerCardDetails, objKey, playerIndex, isViewManageTeam) };
                }
                let captainButton = null;
                if (!isPlayInBench && canBeCaptain(playerTotalData)) {
                    captainButton = <div className={ CaptainIconClass } { ...onMakeCaptainHandler }>
                        <span className="si-icon-wrap">
                            <i className="icon-ucl-captain" />
                        </span>
                        <div className="si-action-text">{ isCaptain ? trans.isCaptain : trans.captain }</div>
                    </div>;
                }
                /* remove button */
                let removeButton = <div className="si-action-items"
                    onClick={ (e) => removePlyrBtn(e, playerCardDetails, objKey, playerIndex) }>
                    <span className="si-icon-wrap">
                        <i className="icon-ucl-close" />
                    </span>
                    <div className="si-action-text">{ trans.remove }</div>
                </div>;
                /* substitution button */
                let isSubsAllow = isManageTeam && (getViewState === configPossibleActions["subsAndTransfer"] || getViewState === configPossibleActions["substitution"]) && canSubstitute(playerTotalData);
                let substituteButton = isSubsAllow ? <div className="si-action-items"
                    onClick={ (e) => changeManageTeamView(e, false, configModes.substitution, playerTotalData) }>
                    <span className="si-icon-wrap">
                        { isPlayInBench ? <i className="icon-ucl-substitute-in" /> :
                            <i className="icon-ucl-substitute-out" /> }
                    </span>
                    <div className="si-action-text">{ trans.substitutePc }</div>
                </div> : null;
                /* transfer button */
                let transferButton = isTransAllow ? <div className="si-action-items"
                    onClick={ (e) => changeManageTeamView(e, true, configModes.transfer, playerCardDetails, objKey, playerIndex) }>
                    <span className="si-icon-wrap">
                        <i className="icon-ucl-transfers" />
                    </span>
                    <div className="si-action-text">{ trans.transfer }</div>
                </div> : null;
                if (isTransferMode) {
                    // transfer mode page
                    playerButtons = <div className="si-action-btn-wrp"><div className="si-btn si-btn-primary si-add-plyr-cta"
                        onClick={ (e) => removePlyrBtn(e, playerCardDetails, objKey, playerIndex) }>
                        <i className="icon-ucl-transfers" />

                    </div> <span className="si-action-text">{ trans.transferOut ? trans.transferOut : 'Transfer Out' }</span></div>;


                } else if (isViewManageTeam) {
                    // view manage team page
                    captainButton || substituteButton || transferButton
                        ? (playerButtons = (
                            <div className='si-action-items-wrap'>
                                { captainButton }
                                { substituteButton }
                                { transferButton }
                            </div>
                        ))
                        : null;
                } else if (substitutionMode) {
                    let filteredPlayer = {};
                    const orderToScan = ['4', '3', '2', '1', '0'];
                    find(orderToScan, (position) => {
                        find(tData[position], (player, index) => {
                            if (player.DBDetails.Id == playerCardDetails.Id) {

                                filteredPlayer = player;
                            }

                        });
                    });

                    if (filteredPlayer.toBeSubstituted) {
                        //cancle subs
                        substituteButton = <div className="si-action-items"
                            onClick={ (e) => cancelSubstitution(filteredPlayer) }>
                            <span className="si-icon-wrap">
                                { isPlayInBench ? <i className="icon-ucl-substitute-in" /> :
                                    <i className="icon-ucl-substitute-out" /> }
                            </span>
                            <div className="si-action-text">{ trans.cancelSubs ? trans.cancelSubs : "Cancel Substitution" }</div>
                        </div>;
                    } else if (isPlayInBench) {
                        //subs in
                        substituteButton = <div className="si-action-items"
                            onClick={ (e) => { common.customTracking('Substitute - Player Card', '	/uclfantasy/my-team/substitutions/'); makeSubstitution(filteredPlayer) } }>
                            <span className="si-icon-wrap">
                                { isPlayInBench ? <i className="icon-ucl-substitute-in" /> :
                                    <i className="icon-ucl-substitute-out" /> }
                            </span>
                            <div className="si-action-text">{ isPlayInBench ? (trans.substituteIn ? trans.substituteIn : "Substitute In") : (trans.substituteOut ? trans.substituteOut : "Substitute out") }</div>
                        </div>;

                        if (tData.substitutionInitiated && tData.IsBenchSubstitution && !filteredPlayer.toBeSubstituted) {
                            //switch order
                            substituteButton = <div className="si-action-items"
                                onClick={ (e) => { common.customTracking('Substitute Switch - Player Card', '/uclfantasy/my-team/substitutions/'); makeSubstitution(filteredPlayer) } }>
                                <span className="si-icon-wrap">
                                    { isPlayInBench ? <i className="icon-ucl-switch-in" /> :
                                        <i className="icon-ucl-switch-out" /> }
                                </span>
                                <div className="si-action-text">{ trans.switchorder ? trans.switchorder : "Switch order" }</div>
                            </div>;
                        }
                    } else {
                        //subs of
                        substituteButton = <div className="si-action-items"
                            onClick={ (e) => { common.customTracking('Substitute - Player Card', '	/uclfantasy/my-team/substitutions/'); makeSubstitution(filteredPlayer) } }>
                            <span className="si-icon-wrap">
                                { isPlayInBench ? <i className="icon-ucl-substitute-in" /> :
                                    <i className="icon-ucl-substitute-out" /> }
                            </span>
                            <div className="si-action-text">{ isPlayInBench ? (trans.substituteIn ? trans.substituteIn : "Substitute In") : (trans.substituteOut ? trans.substituteOut : "Substitute out") }</div>
                        </div>;
                    }

                    playerButtons = <div className="si-action-items-wrap">
                        { substituteButton }
                    </div>;


                } else {
                    // create team page
                    playerButtons = <div className="si-action-items-wrap">
                        { captainButton }
                        { removeButton }
                    </div>;
                }
            } else {
                let addButton = null;
                let transferModeButton = null;
                let playerActionBtnClass = common.makeClasses({
                    'si-btn': true,
                    'si-btn-primary': true,
                    'si-add-plyr-cta': true,
                    'si-disabled': (playerCount >= maxPerTeamCount),
                    'si-click-disable': common.disablePlayer(teamData, playerCardDetails, teamData.max_playerPerTeam)
                });
                if (isTransferMode) {
                    transferModeButton =
                        <div className="si-action-btn-wrp">
                            <div className={ playerActionBtnClass } onClick={ () => addOrRemovePlyrBtn(playerCardDetails) }>
                                <i className="icon-ucl-transfers" />

                            </div>
                            <span className="si-action-text">{ trans.transferIn ? trans.transferIn : 'Transfer In' }</span>
                        </div>;

                    let isPlayerNull = {};
                    const orderToScan = ['4', '3', '2', '1', '0'];
                    find(orderToScan, (position) => {
                        find(tData[position], (player, index) => {
                            if (player.id === null && player.DBDetails.Id == playerCardDetails.Id) {
                                isPlayerNull = { skill: player.skill, rowIndex: position, playerIndex: index };
                            }

                        });
                    });

                    if (!isEmpty(isPlayerNull)) {
                        transferModeButton = <div className="si-action-items-wrap">
                            <div className="si-action-items si-view-players si-status-btn" onClick={ () => { openMobilePlayerListing(true, isPlayerNull.skill) } }>
                                <span className="si-icon-wrap"><span className="">{ trans["short" + isPlayerNull.skill] }</span></span>
                                <div className="si-action-text" style={ { "textTransform": "capitalize" } }>{ (trans.view ? trans.view : "View").toLowerCase() + " " + trans[isPlayerNull.skill].toLowerCase() }</div>
                            </div>
                            <div className="si-action-items si-recover-btn" onClick={ (e) => { recoverPlayer(e, playerCardDetails, playerCardDetails.Skill, isPlayerNull.playerIndex) } }>
                                <span className="si-icon-wrap"><i className="icon-ucl-recover"></i></span>
                                <div className="si-action-text">{ trans.recover || "Recover" }</div>
                            </div>
                        </div>

                        //check if the player is already in team
                        const canRecover = manageTeamPlayersInTeam ? !isPlayInTeam && manageTeamPlayersInTeam.indexOf(playerCardDetails.Id) > -1 : false;

                        if (canRecover && fromPlayerInfo == "true") {
                            transferModeButton = <div className="si-action-items si-recover-players" onClick={ (e) => { recoverPlayer(e, playerCardDetails, playerCardDetails.Skill, isPlayerNull.playerIndex, "fromPlayerInfo") } }>
                                <span className="si-icon-wrap"><i className="icon-ucl-recover"></i></span>
                                <div className="si-action-text">{ trans.recover || "Recover" }</div>
                            </div>
                        }
                    }

                    playerButtons = transferModeButton;
                } else {
                    addButton = !isManageTeam ?
                        <div className="si-action-btn-wrp">
                            <div className={ playerActionBtnClass } onClick={ () => addOrRemovePlyrBtn(playerCardDetails) }>
                                <i className="icon-ucl-pl-add" />

                            </div> <span className="si-action-text">{ trans.addPlayer }</span> </div> : null;
                    playerButtons = addButton;
                }
            }
        }
        return playerButtons;
    }
}

class PlayerCardStatus extends Component {
    render() {
        const trans = this.props.trans;
        const playerCardDetails = this.props.playerCardDetails;
        const pData = this.props.pData;
        const isTourActive = (+pData.IsTourActive === 1 || pData.IsTourActive === "1");
        const isFixtureUpdated = (+pData.IsFixtureUpdated === 1 || pData.IsFixtureUpdated === "1");
        let selPer = playerCardDetails.SelPer;
        let totPts = playerCardDetails.TotPts;
        let pPrice = playerCardDetails.Value;
        return <div className="si-overall-stats-wrap">
            <div className="si-info-item">
                <div className="si-titles">{ trans.SelPer }</div>
                <div className="si-data">
                    <span className="si-pts-num">{ selPer }</span>
                    <span className="si-small-font">%</span>
                </div>
            </div>
            <div className="si-info-item">
                <div
                    className="si-titles">{ (isTourActive && isFixtureUpdated) ? trans.TPoints : trans.lastSeasonYear }</div>
                <div className="si-data">
                    <span className="si-pts-num">{ totPts }</span>
                    <span className="si-small-font">{ trans.labelPts }</span>
                </div>
            </div>
            <div className="si-info-item">
                <div className="si-titles">{ trans.price }</div>
                <div className="si-data">
                    <span className="si-currency-font">€</span>
                    <span className="si-pts-num">{ pPrice }</span>
                    <span className="si-small-font">{ trans.million }</span>
                </div>
            </div>
        </div>
    }
}

class PlayerCardGraph extends Component {
    handleResize = (rect) => {
        this.setState({
            dimensions: rect.bounds
        })
    };
    searchMatchDayIndex = (matches, currGD) => {
        if (this.props.gameday) {
            currGD = this.props.gameday;
        }
        let matchDay = matches;
        let slideToMd = 0;
        for (let i = 0; i < matchDay.length; i++) {
            if (matchDay[i].GDID === currGD) {
                slideToMd = i;
                break;
            }
        }

        if (currGD != undefined && this.props.overview) {
            slideToMd = Math.sign(currGD - 1) ? (currGD - 1) : 0
        }
        return slideToMd;
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.pData.Id !== this.props.pData.Id) {
            const pData = nextProps.pData;
            const matchDay = pData.pDataPer ? pData.pDataPer : [];
            let currGD = nextProps.currGDFromConst;
            if (this.props.OppCurrTeamGDID) {
                currGD = this.props.OppCurrTeamGDID;
            }

            const slideToMd = this.searchMatchDayIndex(matchDay, currGD);
            nextProps.onGraphTap(matchDay[slideToMd]);
        }
    }

    render() {
        const trans = this.props.trans;
        const pData = this.props.pData;
        const playerCardDetails = this.props.playerCardDetails;
        // const isTourActive = (pData.IsTourActive===1 || pData.IsTourActive==="1");
        const isFixtureUpdated = (pData.IsFixtureUpdated === 1 || pData.IsFixtureUpdated === "1");
        const matchDay = pData.pDataPer ? pData.pDataPer : [];
        const onGraphTap = this.props.onGraphTap;
        let matchDayData = this.props.matchDayData ? this.props.matchDayData : {};
        let headingText = trans.upcomingFixtures;
        for (let i = 0; i < matchDay.length; i++) {
            if (+matchDay[i].MStatus > 0) {
                headingText = trans.pointPerMatchDay;
                break;
            }
        }
        const params = {
            slidesPerView: 'auto',
            freeMode: true,
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: true,
            },
        };
        let currGD = this.props.currGDFromConst;
        if (this.props.OppCurrTeamGDID) {
            currGD = this.props.OppCurrTeamGDID;
        }
        let slideToMd = this.searchMatchDayIndex(matchDay, currGD);

        if (slideToMd > 4) {
            params["initialSlide"] = slideToMd;
        }
        return (isFixtureUpdated ?
            <div className="si-md-pts-wrap si-md-pts-graph">
                <span className="si-pts-heading">{ headingText }</span>
                <div className="si-pts-details-wrap">
                    <Swiper { ...params }>
                        {
                            matchDay.map(function (md, index) {
                                let barClass = (matchDayData.GDID ? (md.GDID === matchDayData.GDID) : index === 0) ? "si-per-day-data si-current" : "si-per-day-data";
                                let graphClass = (md.points.TPoints < 0) ? "si-graph-wrap si-negative-graph" : "si-graph-wrap";
                                const postMatchNotPlayed = (md.stats && md.stats.OF <= 0 && +md.MStatus === 2);
                                graphClass = postMatchNotPlayed ? 'si-graph-wrap si-notplayed' : graphClass;
                                let TID = playerCardDetails.TID || playerCardDetails.TeamId || 0;
                                let oppID = (TID.toString() === md.ATID.toString()) ? md.HTID : md.ATID;
                                let atId = config.UEFAImgBase + `teams/logos/140x140/${oppID}.png`;
                                let barHeightStyle,
                                    insideGraph,
                                    outsideGraph;
                                if (md.points.TPoints < 0) {
                                    // negative bar
                                    barHeightStyle = {};
                                    insideGraph = <span>{ md.points.TPoints }</span>;
                                    outsideGraph = '';
                                } else {
                                    // positive bar
                                    if (md.totalPointPercent < 25) {
                                        barHeightStyle = md.totalPointPercent === 0 ? { height: '2px' } : { height: md.totalPointPercent + '%' };
                                        insideGraph = '';
                                        outsideGraph =
                                            <div className="si-outnum"><span>{ md.points.TPoints }</span></div>;
                                    } else {
                                        barHeightStyle = { height: md.totalPointPercent + '%' };
                                        insideGraph = <span>{ md.points.TPoints }</span>;
                                        outsideGraph = '';
                                    }
                                }
                                insideGraph = postMatchNotPlayed ? <span className="icon-ucl-suspended" /> : insideGraph;
                                outsideGraph = postMatchNotPlayed ? '' : outsideGraph;
                                return (<div key={ md.GDID } data-matchid={ md.MID } className={ barClass }
                                    onClick={ () => onGraphTap(md) }>
                                    {
                                        md.MStatus === '0' ?
                                            (<span className="si-md-club-img">
                                                <img src={ atId } alt="" />
                                            </span>) :
                                            (<div className={ graphClass }>
                                                <div className="si-bar-graph" style={ barHeightStyle }>
                                                    { insideGraph }
                                                </div>
                                                { outsideGraph }
                                            </div>)
                                    }
                                    <div className="si-match-day">{ trans.md }{ md.GDID }</div>
                                </div>);
                            })
                        }
                    </Swiper>
                </div>
            </div> : '')
    }
}

class PlayerStatsByMatchDay extends Component {
    render() {
        const trans = this.props.trans;
        const config = this.props.config;
        const pData = this.props.pData;
        // const isTourActive = (pData.IsTourActive===1 || pData.IsTourActive==="1");
        const isFixtureUpdated = (pData.IsFixtureUpdated === 1 || pData.IsFixtureUpdated === "1");
        const playerCardDetails = this.props.playerCardDetails;
        let DefaultMatchDayData = pData && pData.pDataPer ? pData.pDataPer[0] : {};
        let matchDayData = this.props.matchDayData ? this.props.matchDayData : DefaultMatchDayData;
        let matchStatus = matchDayData.MStatus;
        let MMinutes = matchDayData.MMinutes;
        let Phase = matchDayData.Phase;
        let liveStatus = matchDayData.liveStatus;
        let HTID = matchDayData.HTID;
        let htName = matchDayData.HTName;
        let htImg = config.UEFAImgBase + `teams/logos/140x140/${HTID}.png`;
        let htScr = matchDayData.HTScr ? matchDayData.HTScr : 0;
        let ATID = matchDayData.ATID;
        let atName = matchDayData.ATName;
        let atImg = config.UEFAImgBase + `teams/logos/140x140/${ATID}.png`;
        let atScr = matchDayData.ATScr ? matchDayData.ATScr : 0;
        let fixtureHeader = '';
        let fixtureHeaderClass = 'si-stats-details si-fixture-details';
        if (matchStatus === '0') { //upcoming  si-upcoming
            let matchTime = '';
            let matchDate = matchDayData.DateTime;
            let displayDate = '';
            if (matchDate) {
                // let currDate = moment(common.calcTime(window.serverDate, this.props.constraints.OffSet));
                // matchDate = moment(new Date(matchDate));
                // let date = matchDate.format('DD MMM');
                // matchTime = matchDate.format('HH:mm');
                // let dateDiff = matchDate.diff(currDate, 'days');
                // date = (dateDiff === 0 ? trans.today : dateDiff === 1 ? trans.tomorrow : date);
                // displayDate = date;
                displayDate = getTeamDeadlineObj(trans, this.props.constraints.OffSet, matchDate).displayDate;
                matchTime = getTeamDeadlineObj(trans, this.props.constraints.OffSet, matchDate).matchTime;
            }
            fixtureHeader = <div className="si-upcoming si-center-block">
                <span className="si-match-date">{ displayDate }</span>
                <span className="si-match-time">{ matchTime }</span>
            </div>
        } else if (matchStatus === '1') { //live
            fixtureHeaderClass = 'si-stats-details si-fixture-details si-match-live';
            fixtureHeader = <div className="si-live si-center-block">
                <span>{ htScr } - { atScr }</span>
                { liveStatus == 1 ? <span>{ "FT" }</span> :
                    Phase == "HT" ? <span>{ Phase }</span> : <span>{ MMinutes ? (MMinutes + "'") : "0'" }</span> }
            </div>
        } else if (matchStatus === '2') { //result
            fixtureHeader = <div className="si-complete si-center-block">
                <span>{ htScr } - { atScr }</span>
            </div>
        }
        let statsObj = matchDayData.stats;
        let pointsObj = matchDayData.points;
        return ((isFixtureUpdated) ? <div className={ fixtureHeaderClass }>
            <div className="si-fixture-header">
                <div className="si-team-one">
                    <span className="si-teamname">
                        <span>{ htName }</span>
                    </span>
                    <span className="si-teamlogo si-flexBox">
                        <img src={ htImg } alt="" />
                    </span>
                </div>
                { fixtureHeader }
                <div className="si-team-two">
                    <span className="si-teamlogo si-flexBox">
                        <img src={ atImg } alt="" />
                    </span>
                    <span className="si-teamname">
                        <span>{ atName }</span>
                    </span>
                </div>
            </div>
            {
                (!(+statsObj["OF"] > 0) && +matchStatus === 2) ?
                    <div className="si-training-details">
                        <div className="si-training-type"><span>{ trans.matchNotPlayed }</span></div>
                    </div> :
                    (+matchStatus === 0 && (playerCardDetails.MatchAtd && playerCardDetails.MatchAtd !== '')) ?
                        <div className="si-training-details">
                            <div className="si-trainy-icon">
                                <i className="icon-ucl-training" />
                            </div>
                            <div className="si-training-type">
                                <span>{ trans.trainingLabel }</span><span>{ playerCardDetails.Trained }</span></div>
                            <div className="si-plyr-desc">{ playerCardDetails.MatchAtd }</div>
                        </div> :
                        ((statsObj && Object.keys(statsObj).length > 0) ?
                            <PrintStats statsObj={ statsObj } pointsObj={ pointsObj } trans={ trans } pData={ pData } /> : '')
            }
        </div> : '')
    }
}

class SeasonStats extends Component {
    render() {
        const trans = this.props.trans;
        const pData = this.props.pData;
        const onPtsSysIconClick = this.props.onPtsSysIconClick;
        const showTooltip = this.props.showTooltip;
        const isTourActive = (pData.IsTourActive === 1 || pData.IsTourActive === "1");
        const isFixtureUpdated = (pData.IsFixtureUpdated === 1 || pData.IsFixtureUpdated === "1");
        let statsObj = pData.OverallStats ? pData.OverallStats : {};
        let pointsObj = pData.OverallPoints ? pData.OverallPoints : {};
        let seasonStatsBlock = '';
        const ptsSysTooltipClass = common.makeClasses({
            'si-tooltip-wrp': true,
            'si-active': showTooltip
        });
        if (statsObj["OF"] > 0) {
            seasonStatsBlock = <React.Fragment>
                <div className="si-stats-details si-season-details">
                    <div className="si-fixture-header">
                        <span
                            className="si-heading">{ (isTourActive && isFixtureUpdated) ? trans.thisSeason : trans.lastSeason }</span>
                    </div>
                    {
                        (statsObj && Object.keys(statsObj).length > 0) ?
                            <PrintStats statsObj={ statsObj } pointsObj={ pointsObj } trans={ trans } pData={ pData } /> : ''
                    }
                </div>
                <div className="si-pts-system-wrap">
                    <span>{ trans.pointsSystem }</span>
                    <div className={ ptsSysTooltipClass }>
                        <i className="icon-ucl-more_nfo" onClick={ () => onPtsSysIconClick() }></i>
                        { showTooltip ? <OutsideNotifier handler={ () => onPtsSysIconClick() }>
                            <div className="si-tooltip">
                                <span>{ trans.pointsSystemTooltip }</span>
                            </div>
                        </OutsideNotifier> : null }
                    </div>
                </div>
            </React.Fragment>;
        } else {
            seasonStatsBlock = (!(isTourActive && isFixtureUpdated)) ? <div className="si-training-details">
                <div className="si-training-type"><span>{ trans.notInLastSeason }</span></div>
            </div> : ''
        }
        return seasonStatsBlock;
    }
}

class PrintStats extends Component {
    render() {
        const trans = this.props.trans;
        const statsObj = this.props.statsObj;
        const pointsObj = this.props.pointsObj;
        let statsKeys = [
            { key: 'OF', transKey: 'minutesPlayed' },
            { key: 'CS', transKey: 'CS' },
            { key: 'GA', transKey: 'GA' },
            { key: 'GC', transKey: 'GC' },
            { key: 'GS', transKey: 'GS' },
            { key: 'OG', transKey: 'OG' },
            { key: 'PC', transKey: 'PC' },
            { key: 'PE', transKey: 'PE' },
            { key: 'PM', transKey: 'PM' },
            { key: 'PS', transKey: 'PS' },
            { key: 'RC', transKey: 'RC' },
            { key: 'SS', transKey: 'SS' },
            { key: 'YC', transKey: 'YC' },
            { key: 'BR', transKey: 'BR' },
            { key: 'GOB', transKey: 'GOB' },
        ];
        let StatsKeyFilter = statsKeys.filter(function (sk, index) {
            let keyStats = (!isNaN(statsObj[sk.key]) ? statsObj[sk.key] : 0);
            if (keyStats > 0) {
                return sk;
            }
            else {
                return false;
            }
        });
        let statsList = '';
        if (StatsKeyFilter.length > 0) {
            statsList = <div className="si-fixture-body">
                {
                    StatsKeyFilter.map(function (sk, index) {
                        let keyStats = !isNaN(statsObj[sk.key]) ? statsObj[sk.key] : 0;
                        let keyPoints = !isNaN(pointsObj[sk.key]) ? pointsObj[sk.key] : 0;
                        let pointClass = keyPoints < 0 ? 'si-pts-wrap si-negative-pts' : 'si-pts-wrap';
                        return ((keyStats > 0) ? <div className="si-stats-wrap" key={ sk.key }>
                            <span className="si-plyr-events">{ keyStats } { trans[sk.transKey] }</span>
                            <div className={ pointClass }>
                                <span className="si-points">{ keyPoints } </span><span
                                    className="si-pts-txt">{ trans.labelPts }</span>
                            </div>
                        </div> : '');
                    })
                }
                {
                    <div className="si-total-pts">
                        <span>{ trans.TPoints } </span><span className="si-points">{ pointsObj["TPoints"] }</span><span
                            className="si-pts-txt"> { trans.labelPts }</span>
                    </div>
                }
            </div>
        }
        return statsList;
    }
}

const mapSateToProps = (state) => {
    return {
        constraints: state.appData.constraints,
        trans: state.appData.trans,
        isPlayerCardVisible: state.formationData.isPlayerCardVisible,
        overview: state.formationData.overview,
        gameday: state.formationData.gameday,
        playerCardDetails: state.formationData.playerCardDetails,
        fromPlayerInfo: state.formationData.playerInfoClicked,
        playerCardFetchData: state.formationData.playerCardFetchData,
        playerData: state.formationData.playerData,
        teamData: state.formationData.teamData,
        mode: state.formationData.mode,
        userSpecificFixtures: state.formationData.userSpecificFixtures,
        currentActiveFixture: state.formationData.currentActiveFixture,
        manageTeamMode: state.formationData.manageTeamMode,
        manageTeamPlayersInTeam: state.formationData.manageTeamRawData.playersInTeam,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        addOrRemovePlayer: (player) => dispatch(addOrRemovePlayer(player)),
        removePlayer: (obj) => dispatch(removePlayer(obj)),
        makeCaptain: (obj, objKey, playerIndex) => dispatch(makeCaptain(obj, objKey, playerIndex)),
        playerCardFetchData: (id) => dispatch(playerCardFetchData(id)),
        triggerHandlePlayerCard: (isPlayerCardVisible, payload) => dispatch(triggerHandlePlayerCard(isPlayerCardVisible, payload)),
        triggerPlayerSkillsFilter: (skill) => dispatch(triggerPlayerSkillsFilter(skill)),
        triggerLiveScoreFetchData: () => dispatch(triggerLiveScoreFetchData()),
        setManageTeamMode: (mode) => dispatch(setManageTeamMode(mode)),
        initiateSubstitution: (player) => dispatch(initiateSubstitution(player)),
        resetAllFilters: () => dispatch(resetAllFilters()),
        openMobilePlayerListing: (bool) => dispatch(openMobilePlayerListing(bool)),
        triggerResetSkillsFilter: () => dispatch(triggerResetSkillsFilter()),
        makeSubstitution: (player) => dispatch(makeSubstitution(player)),
        cancelSubstitution: (player) => dispatch(cancelSubstitution(player)),
    };
};
export default connect(mapSateToProps, mapDispatchToProps)(PlayerCard);


// WEBPACK FOOTER //
// ./src/components/playerCard/index.js